import React from "react";
import { Card, Row, Spinner } from "react-bootstrap";
import PrimaryButton from "../../components/PrimaryButton";
import FileUploadComponent from "../../components/FileUploadComponent";
import i18n from "../../constants/Strings";
import useReplenishmentUploadViewController from "../../viewControllers/ReplenishmentViewControllers/ReplenishmentUploadViewController";


const ReplenishmentUpload = () => {

    const {
        setUploadFile,
        onContinue,
        enableUpload,
        loading,
        uploadFile,
        fileName,
        setFileName,
        downloadSampleCSV
    } = useReplenishmentUploadViewController();


    const text = {
        rulesHeading: i18n.t('replenishment.replenishmentUpload.rulesHeading'),
        rulesToUpload: i18n.t('replenishment.replenishmentUpload.rulesToUpload'),
        sampleCSV: i18n.t('replenishment.replenishmentUpload.sampleCSV'),
        downloadBtn: i18n.t('replenishment.replenishmentUpload.downloadBtn'),
        fileTemplateHeading: i18n.t('replenishment.replenishmentUpload.fileTemplateHeading'),
        file: i18n.t('replenishment.replenishmentUpload.file'),
        uploadBtn: i18n.t('replenishment.replenishmentUpload.uploadBtn'),
    }
    return (
        <>
            <div className="col-md">
                <Card className="p-3">
                    <h5>{text.rulesHeading}</h5>
                    <ul className="p-2">
                        {text.rulesToUpload.map((rule, index) => (
                            <li key={index}>
                                <p className="text-left text-secondary">{rule}</p>
                            </li>
                        ))}
                    </ul>
                    <div className="row">
                        <div className="col">
                            <h5 className="text-left">{text.fileTemplateHeading}</h5>
                            <h6 className="text-left text-secondary">
                                {text.sampleCSV}
                            </h6>
                        </div>
                        <div className="col d-flex align-items-center justify-content-end">
                            <a
                                className="text-dark"
                                href="#"
                                onClick={downloadSampleCSV}
                            >
                                {text.downloadBtn}
                            </a>
                        </div>
                    </div>
                </Card>
            </div>
            <div className="col-md mt-3">
                <div className="col-md">
                    <Row>
                        <div className=" d-flex align-items-center justify-content-center mt-3">
                            <h6 className=" align-items-center mr-3">{text.file}</h6>
                            <div className="w-50">

                                <FileUploadComponent
                                    key={uploadFile ? uploadFile.name : ""}
                                    setSelectedFile={setUploadFile}
                                    setFileName={setFileName}
                                    fileName={fileName}
                                    fileType={".csv"}
                                />
                            </div>

                        </div>

                    </Row>
                    {loading ? <Spinner /> : (
                        <PrimaryButton
                            disabled={!enableUpload}
                            type="submit"
                            text={text.uploadBtn}
                            className="mt-2 justify-content-center width-auto"
                            onClick={onContinue}
                        />
                    )}
                </div>
            </div>
        </>
    )

};

export default ReplenishmentUpload;


